/**
 * The Routine (was The System). Drives `sections/product-system.liquid`: Add
 * the system puts every listed product in the bag in ONE /cart/add.js call, then
 * announces the new cart exactly as the buy box does (`assets/main-product.js`):
 * the header's `[data-cart-count]` and a `cart:change` event on document.
 *
 * Each card's own Add to bag is the collection cards' quick add
 * (`assets/product-card.js`), not this file.
 *
 * Section-scoped, idempotent, re-run on `shopify:section:load`.
 */
(function () {
  var RESET_AFTER = 2000;

  function root() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function init(section) {
    if (section.dataset.systemReady === 'true') return;
    section.dataset.systemReady = 'true';

    var button = section.querySelector('[data-system-add]');
    var label = section.querySelector('[data-system-label]');
    var errorNode = section.querySelector('[data-system-error]');
    var data = {};
    try {
      data = JSON.parse(section.querySelector('[data-system-json]').textContent);
    } catch (e) { /* fall back to the rendered label */ }
    if (!button) return;

    function showError(message) {
      if (!errorNode) return;
      errorNode.textContent = message || '';
      errorNode.hidden = !message;
    }

    button.addEventListener('click', function () {
      if (button.disabled || !window.fetch) return;
      var ids = (button.dataset.ids || '').split(',').filter(Boolean);
      if (!ids.length) return;

      showError('');
      button.disabled = true;
      window.clearTimeout(button._ddjReset);
      button.dataset.state = 'adding';
      if (label && data.addingLabel) label.textContent = data.addingLabel;

      var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
      /* With the bag on the page, one request that opens and fills it
       * (assets/cart.js); the bag shows any refusal itself. */
      var viaBag = !!(window.DDJCart && window.DDJCart.add);
      var adding = viaBag
        ? window.DDJCart.add({ items: items })
        : fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (body) {
              if (!response.ok) throw body;
              return body;
            });
          })
          .then(function () {
            return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (node) {
              node.textContent = node.textContent.replace(/\((\d+)\)/, '(' + cart.item_count + ')');
            });
            document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart, source: 'product-system' } }));
          });

      adding
        .then(function () {
          button.dataset.state = 'added';
          if (label && data.addedLabel) label.textContent = data.addedLabel;
          button._ddjReset = window.setTimeout(function () {
            button.dataset.state = 'idle';
            if (label && data.label) label.textContent = data.label;
            button.disabled = false;
          }, RESET_AFTER);
        })
        .catch(function (error) {
          button.dataset.state = 'idle';
          if (label && data.label) label.textContent = data.label;
          button.disabled = false;
          var text = (error && error.description) || data.errorLabel || '';
          showError(text);
          /* The bag drawer shows the same message (assets/cart.js). */
          if (!viaBag) document.dispatchEvent(new CustomEvent('cart:error', { detail: { message: text, source: 'product-system' } }));
        });
    });
  }

  function run(scope) {
    (scope || document).querySelectorAll('[data-product-system]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', function (event) {
    run(event.target);
  });
})();
